import { useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeContainer, InvestUs, OurServices } from './home.styles';
import { Banner } from 'src/utilities/UILibrary/Media/Banner/Banner';
import Sponsors from '../../../components/Layout/sponsors/sponsors';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const [number, setNumber] = useState(1);
  const navigate = useNavigate();

  const goBack = () => {
    if (number <= 1) {
      setNumber(4);
    } else {
      setNumber(number - 1);
    }
  };

  const goForward = () => {
    if (number >= 4) {
      setNumber(1);
    } else {
      setNumber(number + 1);
    }
  };

  return (
    <HomeContainer>
      <Banner
        className="banner-container"
        imgSrc={`${process.env.REACT_APP_BUCKET_FINSPHERA}/img_home_principal_1.jpg`}
      >
        <h2>
          Nosotros somos la primera plataforma de Financiamiento Colectivo (Crowdfunding) Ambiental,
          Social y con buen Gobierno Corporativo. Gracias a tu participación estamos impactando
          positivamente a nuestra comunidad y a nuestro Medio Ambiente.{' '}
          <span>¡Tú eres el factor de impacto que estábamos buscando!</span>
        </h2>
        <p>
          Ya puedes solicitar crédito a una tasa justa para tu empresa. Si eres inversionista puedes
          financiar empresas recibiendo completa la tasa de interés porque no hay intermediarios.
        </p>
        <Button isFullWidth onClick={() => navigate('/iniciar-sesion')}>
          Ingresar
        </Button>
      </Banner>

      <Sponsors />
      <InvestUs>
        <div>
          <h2>Invierte con nosotros</h2>
        </div>
        <div>
          <div>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_home_invest_money.png`}
                alt="Finsphera genera intereses"
              />
            </figure>
            <h3>Que tu dinero genere intereses</h3>
            <p>
              Ponlo a trabajar impulsando empresas que cumplen con buenas Prácticas Sociales,
              Ambientales y de Buen Gobierno.
            </p>
          </div>
          <div>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_home_invest_time.png`}
                alt="Finsphera plazos 30 a 90 días"
              />
            </figure>
            <h3>Plazos de 30 a 150 días</h3>
            <p>Invierte a Corto Plazo generando atractivos rendimientos.</p>
          </div>
          <div>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_home_invest_impact.png`}
                alt="Finsphera tu eres el factor de impacto"
              />
            </figure>
            <h3>Tú eres el Factor de Impacto</h3>
            <p>
              Muchas gracias por ayudarnos a transformar nuestra comunidad y nuestro Medio Ambiente.
            </p>
          </div>
        </div>
      </InvestUs>
      <OurServices>
        <div>
          <h2>Nuestros servicios:</h2>
          <div>
            <Link to="/solicitante/inicio">Solicita un crédito</Link>
            <Link to="/inversionista/iniciar-sesion">Invierte</Link>
          </div>
        </div>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/img_home_our_services.png`}
            alt="FinSphera nuestros servicios"
          />
        </figure>
      </OurServices>
    </HomeContainer>
  );
}
